import nav from './en/nav.json'
import labels from './en/labels.json'
import errors from './en/errors.json'
import messages from './en/messages.json'
import pl from './en/placeholders.json'

export default { nav, labels, errors, messages, pl }
